export const OWNER = 'titular';
export const AUTHORIZED = 'autorizado';
export const COOWNER = 'cotitular';
export const REPRESENTATIVE = 'apoderado';
